<template>
    <div class="memo">
      <el-row class="tac">
        <el-col :span="4">
          <el-menu default-active="1"  class="el-menu-vertical-demo" @select="findItem">
            <template >
                <el-menu-item v-for="(menu, i) in menuInfo" :key="(i+1)" :index="i + ''">
                        <i class="el-icon-menu"></i>
                        <span>{{menu.time}}</span>
                </el-menu-item>
            </template>
          </el-menu>
        </el-col>
      <el-col :span="18">
        <div style="top:3%;left:10%">
            <el-col  v-for="(memo, i) in memoList"  :key="(i+1)" :span="7"  style="margin-top:2%; margin-left:3.5%" v-model="memoList">
                <el-card class="box-card" style="width:100%" shadow="hover">
                    <div slot="header" class="clearfix" style=" height: 20px;" >
                      <el-col :span="18" > <span style="margin-left:3%;float:left;font-size:20px">{{memo.title}}</span> </el-col>
                      <el-col :span="6"> <el-switch v-model="memo.state"  active-color="#67C23A" inactive-color="#F56C6C" @change="stateChange(memo)"></el-switch> </el-col>
                    </div>
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 8, maxRows: 8}"
                        v-model= "memo.text">
                    </el-input>
                    <el-button style="float: right; margin-top:2%; margin-bottom:2%" :type="deleteType(memo)" size="mini" @click="deleteBeforeMemo(memo)">删除</el-button>
                </el-card>
            </el-col>
            <div style=" left:50% ;bottom: 5%; position:fixed">
              <el-button
                      type="primary"
                      @click='dialogFormVisible = true'>新建备忘</el-button>
            </div>
        </div>
      </el-col>
      </el-row>

      <el-dialog title="新建备注" :visible.sync="dialogFormVisible">
        <el-row>
          <el-col :span="4" style="margin-top:1%">新备忘标题:</el-col>
          <el-col :span="18">
            <el-input placeholder="请输入内容" v-model="newMemo.title"  clearable> </el-input>
          </el-col>
        </el-row>
        <el-row style="margin-top:2%">
          <el-col :span="4" style="margin-top:1%">新备忘截止日期:</el-col>
          <el-col :span="18">
            <el-date-picker v-model="newMemo.time" type="date"  style="width:100%" placeholder="选择日期"> </el-date-picker>
          </el-col>
        </el-row>
        <el-row style="margin-top:2%">
          <el-col :span="4">新备忘内容:</el-col>
          <el-col :span="18">
            <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 6}"   v-model= "newMemo.text"> </el-input>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="creatMemo">确 定</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
import Common from './Common'
export default {
  name: 'Memo',
  data () {
    return {
      dialogFormVisible: false,
      newMemo: {
        title: '',
        text: '',
        time: ''
      },
      memoList: [],
      menuInfo: [],
      deleteType: function (memo) {
        if (memo.state === true) return 'success'
        if (memo.state === false) return 'danger'
        return 'primary'
      }
    }
  },
  mounted () {
    this.getMemoTime()
  },
  methods: {
    deleteMemo (memo) {
      this.$axios.get(Common.baseUrl + 'memo/deleteMemoById', {params: {id: memo.id}}
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.$message({
            message: '删除备忘成功！',
            type: 'success'
          })
          this.getMemoTime()
          this.findItemByTime(memo.time)
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    deleteBeforeMemo (memo) {
      this.$confirm('是否删除备注  ' + memo.title + '  ?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteMemo(memo)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    findItem (key, keyPath) {
      this.findItemByTime(this.menuInfo[key].time)
    },
    findItemByTime (time) {
      this.$axios.get(Common.baseUrl + 'memo/findMemo', {params: {time: time}}
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.memoList = res.data.data
          for (let i in this.memoList) {
            if (this.memoList[i].state === 0) this.memoList[i].state = false
            else this.memoList[i].state = true
          }
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    creatMemo () {
      this.$axios.post(Common.baseUrl + 'memo/creatMemo', this.newMemo
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.$message({
            message: '新建备忘成功！',
            type: 'success'
          })
          this.dialogFormVisible = false
          this.getMemoTime()
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    getMemoTime () {
      this.$axios.get(Common.baseUrl + 'memo/getMemoTime'
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          let timeList = res.data.data
          this.menuInfo = []
          for (let i in timeList) {
            let s = timeList[i]
            let time = s.substring(0, s.indexOf(' '))
            this.menuInfo.push({time: time})
          }
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    stateChange (memo) {
      let nextState = ''
      if (memo.state === true) {
        nextState = '已完成'
      } else {
        nextState = '未完成'
      }
      this.$axios.get(Common.baseUrl + 'memo/changeState', {params: {id: memo.id}}
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.$message({
            message: '成功更改备忘 ' + memo.title + ' 的状态为 ' + nextState,
            type: 'success'
          })
          // let timeList = res.data.data
          // for (let i in timeList) {
          //   let s = timeList[i]
          //   let time = s.substring(0, s.indexOf(' '))
          //   this.menuInfo.push({time: time})
          // }
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    }
  }
}
</script>

<style>
  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 480px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Memo.vue